import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { IoIosArrowBack } from 'react-icons/io';
import styles from './Lilly.module.css';
import ReactPlayer from 'react-player';
import AlbumPage from './AlbumPage';
import { trackExternalLink } from '../utils/analytics';



const MoviePage = () => {
  const trailerUrl = 'https://www.youtube.com/watch?v=89i4MvTdh8c';
  const trailerThumbnail = 'https://i.ytimg.com/vi/89i4MvTdh8c/maxresdefault.jpg';
  const [isTrailerOpen, setIsTrailerOpen] = useState(false);


  return (
    <div className={styles.moviePage}>
      <div className={styles.header}>
        <Link to="/film/filmscores" className={styles.navigationArrow}>
          <IoIosArrowBack />
        </Link>
      </div>
      <div className={styles.title}>
        Lilly Lives Alone
      </div>
      <div className={styles.topSection}>
        <div className={styles.videoPreviewSection}>
          <button
            type="button"
            className={styles.videoPreviewLink}
            onClick={() => setIsTrailerOpen(true)}
            aria-label="Play Lilly Lives Alone trailer"
          >
            <div className={styles.videoPreviewCard}>
              <img
                src={trailerThumbnail}
                alt="Lilly Lives Alone trailer preview"
                className={styles.videoPreviewImage}
              />
              <div className={styles.playBadge}>▶</div>
            </div>
            <div className={styles.videoPreviewMeta}>
              <div className={styles.videoPreviewEyebrow}>Featured Video</div>
              <div className={styles.videoPreviewTitle}>Lilly Lives Alone</div>
              <div className={styles.videoPreviewType}>Official Trailer</div>
              <div className={styles.videoPreviewIntro}>
                <p>
                  Dark Sky Films has acquired North American rights to Lilly Lives Alone, a psychological horror exploring themes of isolation and grief. Directed by Martin Melnick in his feature debut, the film stars Shannon Beeby as Lilly, a reclusive woman haunted by the trauma of her young daughter's death. As she struggles with hallucinations and encounters Jed, the ghosts of her past resurface, leading to unspeakable horrors. Featuring a cast that includes Jeffrey Combs and Ryan Jonze, Lilly Lives Alone has been praised for its unsettling and thought-provoking approach to horror. Dark Sky Films, known for titles like The House Of The Devil and Stake Land, continues to champion boundary-pushing genre films with this acquisition.
                </p>
                <p>
                  Premiered in 2024 at Brooklyn Horror Film Festival Yellow Veil Pictures at AFM in Las Vegas.
                </p>
              </div>
            </div>
          </button>
          <a
            href="https://darkskyfilms.com/film/lilly-lives-alone/"
            target="_blank"
            rel="noopener noreferrer"
            className={styles.inlineLink}
            onClick={() => trackExternalLink('https://darkskyfilms.com/film/lilly-lives-alone/', 'Lilly Lives Alone — film page')}
          >
            Film page at Dark Sky Films
          </a>
        </div>
        <div className={styles.tracklistPanel}>
          <AlbumPage albumid="229" isEmbedded={true} />
        </div>
      </div>
      <div className={styles.gallery}>
        <div className={styles.galleryItem}>
          <img src={"https://benjamincleek.s3.us-west-2.amazonaws.com/photos/bd85e04b-7c11-4c18-a89b-60bc41fe50aa-Untitled%20drawing.jpg"} alt="Lilly Lives Alone poster" />
        </div>
        <div className={styles.galleryItem}>
          <img src={"https://benjamincleek.s3.us-west-2.amazonaws.com/photos/2c899557-4891-4cb4-8ac0-76f8b3be661a-Lilly%20OG%20Poster.png"} alt="Lilly Lives Alone poster" />
        </div>
        <div className={styles.galleryItem}>
          <img src={"https://benjamincleek.s3.us-west-2.amazonaws.com/photos/5727832f-61d7-4107-bee7-24827ff8028c-Screen%20Shot%202023-12-22%20at%2011.39.45%20AM.png"} alt="Lilly still 1" />
        </div>
        <div className={styles.galleryItem}>
          <img src={"https://benjamincleek.s3.us-west-2.amazonaws.com/photos/faa1e339-78a0-4c77-b8a0-63e7bdaa076e-221c2f66-8475-470d-9e38-16bffcd78e94-4b16f774-c247-411c-9e3c-d11261284a89-Screen%20Shot%202023-12-22%20at%2011.49.40%20AM%20%281%29%20%281%29.png"} alt="Lilly still 2" />
        </div>
        <div className={styles.galleryItem}>
          <img src={"https://benjamincleek.s3.us-west-2.amazonaws.com/photos/13b64fff-7767-44f6-9a05-2c1be290482b-Lilly%20hand%20leaves.jpg"} alt="Lilly still 3" />
        </div>
        <div className={styles.galleryItem}>
          <img src={"https://benjamincleek.s3.us-west-2.amazonaws.com/photos/4fc5ccbe-8530-4291-a9a5-f2078034a3c6-Screen%20Shot%202023-12-22%20at%2011.47.38%20AM.png"} alt="Lilly still 4" />
        </div>
        <div className={styles.galleryItem}>
          <img src={"https://benjamincleek.s3.us-west-2.amazonaws.com/photos/4a07fd24-57d1-4c2f-bc27-fabc183db648-Lilly%20-%20who%27s%20there.jpg"} alt="Lilly still 5" />
        </div>
      </div>
        {isTrailerOpen && (
          <div className={styles.modalOverlay} onClick={() => setIsTrailerOpen(false)}>
            <div className={styles.modalFrame} onClick={(e) => e.stopPropagation()}>
              <ReactPlayer
                url={trailerUrl}
                playing
                controls
                playsinline
                width="100%"
                height="100%"
                config={{
                  youtube: {
                    playerVars: {
                      playsinline: 1,
                      modestbranding: 1,
                      rel: 0,
                    },
                  },
                }}
              />
            </div>
          </div>
        )}
    </div>

  );
};

export default MoviePage;
